import { render, staticRenderFns } from "./DashboardDouble.vue?vue&type=template&id=4d1f8f86&scoped=true"
import script from "./DashboardDouble.vue?vue&type=script&lang=js"
export * from "./DashboardDouble.vue?vue&type=script&lang=js"
import style0 from "./DashboardDouble.vue?vue&type=style&index=0&id=4d1f8f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1f8f86",
  null
  
)

export default component.exports